import { useScrollPosition } from '@contexts/ScrollContext';
import { useEffect, useRef } from 'react';

interface UseLoadMoreStoriesProps {
  isLoadingStories: boolean;
  hasNextPage: boolean;
  onLoadMoreStories: () => void;
}

export const useLoadMoreStories = ({
  isLoadingStories,
  hasNextPage,
  onLoadMoreStories,
}: UseLoadMoreStoriesProps) => {
  const { scrollHeight } = useScrollPosition();
  const storiesDivRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    storiesDivRef.current = document.getElementById('customer-story-list-page') as HTMLDivElement;
  }, []);

  useEffect(() => {
    const storiesListHeight = storiesDivRef.current?.scrollHeight;
    if (
      storiesListHeight &&
      !isLoadingStories &&
      hasNextPage &&
      scrollHeight >= storiesListHeight
    ) {
      onLoadMoreStories();
    }
  }, [scrollHeight]);
};
